import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()(
  (theme) => ({
    menuItem: {
      fontSize: '14px',
    },
    profilePanel: {
      display: 'flex',
      cursor: 'pointer',
      '&:hover': {
        background: '#3a5581',
        borderRadius: '20px',
      },
    },
    infoPopup: {
      display: 'flex',
      flexDirection: 'column',
      minWidth: '200px',
      pointerEvents: 'none',
      marginBottom: theme.spacing(3),
      '&:hover': {
        background: '#FFFFFF !important',
      },
      '&:focus': {
        background: '#FFFFFF !important',
      },
    },
    userName: {
      padding: 10,
      fontWeight: 500,
    },
    caption: {
      color: '#a6a6a6',
    },
    large: {
      width: theme.spacing(11),
      height: theme.spacing(11),
      margin: theme.spacing(1),
    },
    avatar: {
      backgroundColor: '#415f90',
      width: theme.spacing(5),
      height: theme.spacing(5),
      borderRadius: '50%',
      textAlign: 'center',
    },
    avatarContent: {
      lineHeight: '2',
      color: '#dddedd',
      fontSize: '20px',
    },
    largeAvatar: {
      height: theme.spacing(11),
      width: theme.spacing(11),
      margin: '12px',
      borderRadius: '50%',
      backgroundColor: '#415f90',
      textAlign: 'center',
    },
    largeAvatarContent: {
      lineHeight: '2.1',
      fontSize: '42px',
      color: '#fff',
    },
  }),
  // {
  //   name: 'UserProfile',
  // },
);
